import { configureStore } from "@reduxjs/toolkit";
import { authMiddleware } from "src/middleware/authMiddleware";
import { authSlice } from "src/store/auth/authSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(authMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
